// extracted by mini-css-extract-plugin
export var form = "form-module--form--1K67R";
export var form__button = "form-module--form__button--CsBM1";
export var form__input = "form-module--form__input--1V6W9";
export var form__label = "form-module--form__label--QggeZ";
export var linkButton = "form-module--link-button--eaiMK";